import { useSiteContent } from "../../../context/SiteContentContext";
export default function WhyUsSection() {
  const { content } = useSiteContent();
  const reasons = content.why_us_items;
  return (
    <section className="w-full relative overflow-hidden" style={{ minHeight: "520px" }}>
      {/* Full-bleed background image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=1600&h=1040&fit=crop&q=85"
          alt="Why Choose ThermalXpert"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0" style={{ background: "linear-gradient(105deg,rgba(13,40,80,0.88) 0%,rgba(26,95,138,0.75) 50%,rgba(13,40,80,0.6) 100%)" }} />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-8 py-24">
        {/* Header */}
        <div className="text-center mb-14">
          <div
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest mb-4"
            style={{ background: "rgba(74,159,212,0.25)", color: "#7dd3fc", border: "1px solid rgba(74,159,212,0.4)", backdropFilter: "blur(8px)" }}
          >
            <i className="ri-question-line"></i>
            Why Choose Us
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-white leading-tight">
            NYC's Most Trusted<br />
            <span style={{ color: "#7dd3fc" }}>HVAC Company</span>
          </h2>
          <p className="text-white/60 mt-4 max-w-xl mx-auto text-sm leading-relaxed">
            Over 15 years serving Brooklyn and the NYC metro area. Here's why thousands of homeowners and businesses choose ThermalXpert.
          </p>
        </div>

        {/* Reason cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {reasons.map((r) => (
            <div
              key={r.title}
              className="flex flex-col gap-4 p-6 rounded-2xl transition-all duration-300 hover:-translate-y-1"
              style={{ background: "rgba(255,255,255,0.1)", backdropFilter: "blur(16px)", border: "1px solid rgba(255,255,255,0.18)" }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0" style={{ background: "linear-gradient(135deg,#4a9fd4,#2d7ab5)" }}>
                <i className={`${r.icon} text-xl text-white`}></i>
              </div>
              <h3 className="font-black text-white text-base leading-snug">{r.title}</h3>
              <p className="text-sm text-white/65 leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA strip */}
        <div
          className="mt-12 rounded-3xl p-8 flex flex-col md:flex-row items-center justify-between gap-6"
          style={{ background: "rgba(255,255,255,0.1)", backdropFilter: "blur(16px)", border: "1px solid rgba(255,255,255,0.18)" }}
        >
          <div>
            <p className="text-xl font-black text-white">Ready to upgrade your HVAC system?</p>
            <p className="text-sm text-white/60 mt-1">Free estimates — no obligation. Serving all NYC boroughs.</p>
          </div>
          <div className="flex items-center gap-4 flex-shrink-0">
            <a
              href="tel:9296781640"
              className="flex items-center gap-2 px-6 py-3 rounded-full text-sm font-bold text-white whitespace-nowrap cursor-pointer transition-all hover:scale-105"
              style={{ background: "rgba(255,255,255,0.15)", border: "1px solid rgba(255,255,255,0.3)" }}
            >
              <i className="ri-phone-fill"></i>
              (929) 678-1640
            </a>
            <a
              href="#easy"
              onClick={(e) => { e.preventDefault(); document.querySelector("#easy")?.scrollIntoView({ behavior: "smooth" }); }}
              className="flex items-center gap-2 px-6 py-3 rounded-full text-sm font-bold text-white whitespace-nowrap cursor-pointer transition-all hover:scale-105 hover:opacity-90"
              style={{ background: "linear-gradient(135deg,#4a9fd4,#2d7ab5)" }}
            >
              Get Free Quote <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
